// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7454158d","977":"e46fdbc6"}[chunkId] + ".chunk.js";
};